import React from "react";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

const LoadingImage = () => {
  return (
    <div
      style={{
        top: "50%",
        right: 0,
        bottom: 0,
        margin: "0 auto",
        left: "50%",
        textAlign: "center",
      }}
    >
      <Loader type="TailSpin" color="#15b4de" height={80} width={80} />
    </div>
  );
};

export default LoadingImage;
